export const USER = "tapGP::user";
export const SESSION = "tapGP::session";
export const CALL_VARIABLES = "tapGP::call";
export const NOTES_VARIABLES = "tapGP::notes";